<template src="./index.html">
</template>
<script>
	import data from './data.js'
	import UploadFile from './UploadFile/index.vue'
	import ResultsDisplay from './ResultsDisplay/index.vue'
	import uploadresults from './uploadresults/index.vue'
export default {

  name: 'Login',
  components: {
	  UploadFile,ResultsDisplay,uploadresults
  },
  data: function() {
    return {
		headlist: data.headlist,
		chooseindex: 0
    };
  },
  created() {
  },
  methods: {
	  forchooseindex(e){
	  	this.chooseindex=e
	  }
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
